module.exports = __webpack_public_path__ + "img/lachstempuramakioverview.6d7490b5.jpg";